import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext } from "react";

export function FullScreenPleaseSelectMandateNotice() {
  const { lang } = useContext(PspContext);

  return (
    <div className="w-full h-full flex justify-center items-center">
      <p className="text-font-secondary w-2/3 text-center">
        {translate("pleaseSelectMandate", lang)}
      </p>
    </div>
  );
}
